// extracted by mini-css-extract-plugin
export default {"questionMarkContainer":"QuestionMarkAnimation_questionMarkContainer__ROhQU","questionMarkAnimation":"QuestionMarkAnimation_questionMarkAnimation__gay5i"};